module.exports = __webpack_public_path__ + "static/wolfBustersBg-c8bc2adc1fed0a535d8b2e8bac0cc721.jpg";